import { Controller, Path, useFormContext } from "react-hook-form";
import { IFormValues } from "../../types";
import CBFormTextFieldController from "./CBFormTextFieldController";
import GoogleAutocompleteWrapper from "../../../../util/component/GoogleAutocompleteWrapper";
import { useTranslation } from "react-i18next";

interface CBGoogleAutocompleteControllerProps {
    idField?: string,
    formName: Path<IFormValues>,
    label: string,
    showSelect: boolean,
    optionsTypes: string[],
    isDisabled?: boolean,
    handleOnPlaceSelected: (place: any) => string | undefined
}

const CBGoogleAutocompleteController = ({
    idField,
    formName,
    label,
    showSelect,
    optionsTypes,
    isDisabled = false,
    handleOnPlaceSelected
}: CBGoogleAutocompleteControllerProps) => {

    const { t } = useTranslation('customerbase');
    const {control} = useFormContext<IFormValues>();

    return (
        showSelect ?
            <Controller
                control={control}
                name={formName}
                render={({field: {onChange, value}, fieldState: {error}}) => (
                    <GoogleAutocompleteWrapper 
                        googleInputProps={{
                            options: {
                                types: optionsTypes,
                                fields: ['address_components']
                            },
                            onPlaceSelected: (place) => {
                                //console.log(isCreationMode, editing)
                                //console.log(place);
                                
                                const value = handleOnPlaceSelected(place);

                                onChange(value || '');
                                
                            }
                        }}
                        inputProps={{
                            fullWidth: true,
                            //InputProps: {readOnly: readOnly},
                            id: idField,
                            name: idField,
                            type: 'text',
                            label: t(label),
                            error: Boolean(error),
                            helperText: error?.message as string,
                            value: value || '',
                            onChange: onChange,
                            disabled: isDisabled
                        }}
                    />
                )}
            />
        :
            <CBFormTextFieldController
                idField={`${idField}-textfield`}
                formName={formName}
                label={label}
                readOnly
            />
    );

}

export default CBGoogleAutocompleteController;